import axios from 'axios'
import querystring from 'query-string'
import { DomainDto } from '@halo/dtos/domain.dto'
import aqe from '@pushly/aqe'
import FlagList from '@halo/structs/flag-list'
import { FlagModel } from '@halo/models/flag.model'
import { PlatformUserDomainRecord } from '@halo/models/domains/platform-user-domain-record'
import { getRuntimeConfig } from '@halo/_utils/runtime-config'

export const validateSession = async () => {
    const response = await axios.get(`${aqe.defaults.publicApiDomain}/auth/validate-token`)
    return response.data.data
}

export const setCurrentDomainSession = (domain: DomainDto) => {
    window.sessionStorage.setItem('pufferfish.domainSession', JSON.stringify(domain))
}

export const getCurrentDomainSession = () => {
    const domainData = window.sessionStorage.getItem('pufferfish.domainSession')
    if (!domainData) return
    return DomainDto.fromApiResponse(JSON.parse(domainData))
}

export const getCurrentDomainStorage = () => {
    const rawData = window.localStorage.getItem('pufferfish')
    if (!rawData) return
    const jsonData = JSON.parse(rawData)
    if (!jsonData.currentDomainJsonData) return
    return DomainDto.fromApiResponse(JSON.parse(jsonData.currentDomainJsonData))
}

export const fetchAllDomains = async (options?: any): Promise<any> => {
    options = {
        ...options,
        query: {
            pagination: 0,
            ...options.query,
        },
    }

    const searchParams = new URLSearchParams(options.query ?? {})

    const axiosDomains = await axios.get(`${aqe.defaults.publicApiDomain}/v3/domains?${searchParams.toString()}`)
    if (axiosDomains.data.status === 'error') {
        throw axiosDomains.data.message
    }

    const { data: domains, ...meta } = axiosDomains.data
    const domainDtos: DomainDto[] = domains.map((domain: any) => PlatformUserDomainRecord.parseJsonObject(domain))

    return {
        data: domainDtos,
        meta,
    }
}

export const fetchDomain = async (domainId: any, token?: string): Promise<DomainDto> => {
    const headers: any = {}
    if (token) {
        headers.Authorization = 'Bearer '.concat(token)
    }

    const axiosDomains = await axios.get(`${aqe.defaults.publicApiDomain}/v3/domains/${domainId}`, { headers })
    const domain: any = axiosDomains.data
    return DomainDto.fromApiResponse(domain.data)
}

export const fetchFlags = async () => {
    const axiosFlags = await axios.get(`${aqe.defaults.publicApiDomain}/flags?pagination=0`)
    const flags = axiosFlags.data.data
    return FlagList.from(flags, FlagModel.build)
}

export const detectIsSafariBrowser = (): boolean => {
    return 'safari' in self
}

export const shouldUseLegacyAuthHeader = (): boolean => {
    const root = getRuntimeConfig().PLATFORM_ROOT_DOMAIN
    return detectIsSafariBrowser() && !location.hostname.includes(root)
}

export function buildRouteFromHostname(hostName: string) {
    return `https://${hostName}`
}
